import { MascotEmpty } from '../components/Watermark';

const DEFAULT_MESSAGE =
  'Ведутся технические работы. Приложение скоро снова заработает — загляните чуть позже.';

/** Full-screen stub shown to players while the app is in maintenance mode. */
export function MaintenanceScreen({ message }: { message?: string | null }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '32px 24px',
        gap: 16,
      }}
    >
      <MascotEmpty />
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 800, margin: 0 }}>
        Технические работы
      </h1>
      <p style={{ fontSize: 13, color: 'var(--text-3)', maxWidth: 360, margin: 0 }}>
        {message?.trim() || DEFAULT_MESSAGE}
      </p>
    </div>
  );
}
